'use client'

import ChatListPanel from '@/components/atendimento/chat-list/chat-list-panel'
import { MdChat } from 'react-icons/md'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import AtendimentoChatPage from './atendimento-chat-page'

/**
 * Tela cheia do atendimento: a lista à esquerda e a conversa à direita.
 *
 * A lista mora em `ChatListPanel` porque ela também aparece no dock acoplado ao
 * menu, sobre qualquer tela do sistema. Aqui ela guarda o recorte na URL (o link
 * serve para mandar ao colega) e escolher uma conversa navega de verdade.
 */
export default function AtendimentosPage() {
    const { id: selectedChatId } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const location = useLocation()

    const activeChatId = selectedChatId ? parseInt(selectedChatId) : null

    /**
     * Abrir a conversa NÃO pode perder o recorte da lista.
     *
     * O filtro inteiro vive na query string (`useChatFilters`), e navegar para
     * `/atendimento/chats/123` sem ela fazia o hook ler o padrão: quem filtrava,
     * abria uma conversa e voltava encontrava a lista zerada. O comentário no
     * código já prometia o contrário; o que faltava era carregar a busca adiante.
     */
    const openChat = (chatId: number) =>
        navigate({ pathname: `/atendimento/chats/${chatId}`, search: location.search })

    return (
        <div className="flex h-full overflow-hidden">
            <ChatListPanel
                activeChatId={activeChatId}
                onSelectChat={openChat}
                filterStorage="url"
                className={`${activeChatId ? 'hidden lg:flex' : 'flex'} w-full lg:w-96 xl:w-[420px] flex-shrink-0 border-r border-base-300/50`}
            />

            {/* Painel do chat */}
            <div className={`${activeChatId ? 'flex' : 'hidden lg:flex'} flex-1 flex-col min-w-0`}>
                {activeChatId ? (
                    <AtendimentoChatPage />
                ) : (
                    <div className="flex-1 flex flex-col items-center justify-center bg-base-200/30">
                        <div className="w-20 h-20 rounded-full bg-base-200 flex items-center justify-center mb-4">
                            <MdChat className="text-4xl text-base-content/20" />
                        </div>
                        <h3 className="text-lg font-semibold text-base-content/40 mb-1">
                            Selecione um atendimento
                        </h3>
                        <p className="text-sm text-base-content/30">
                            Escolha uma conversa ao lado para visualizar
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}
